import { useState, useEffect } from "react";

export function SkipLink() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Tab") {
        setVisible(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <a
      href="#main-content"
      className={`fixed top-0 left-1/2 -translate-x-1/2 z-[100] bg-primary text-primary-foreground px-4 py-2 rounded-b-md font-medium transition-transform ${
        visible ? "translate-y-0" : "-translate-y-full"
      }`}
      onClick={() => setVisible(false)}
    >
      קפוץ לתוכן העיקרי
    </a>
  );
}
